import React from "react";
import SaFungerarContent from "../../content/public/SaFungerarContent.jsx";

export default function SaFungerarSalespartnerPage() {
  return <SaFungerarContent />;
}
